/* ============
 * Create Page
 * ============
 *
 * This is the page for adding product group.
 */
import { mapGetters } from 'vuex';
import priceFieldService from './../../../../services/priceField';
import priceFieldTransformer from './../../../../transformers/priceField';
import Forms from './../../../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        field: {
          value: '',
          type: 'text',
        },
      }),
      tabIndex: '1',
    };
  },

  created() {
   
  },

  computed: {
    
  },

  methods: {
    /**
     * Method to store the price field.
     */
    store() {
      this.form.loading = true;
      const priceField = priceFieldTransformer.send(this.form.data());
      priceFieldService.store(priceField)
      .then(() => {
        this.form.loading = false;
        this.$message({
            message: this.$t('static.priceFields.create.success'),
            type: 'success',
        });
        this.$router.push({
            name: 'priceFields.index',
        });
      }).catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },
  },

  watch: {
   
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/priceFields/create/create.js